import React, { useEffect } from 'react';
import { FormControl, Text, VStack, } from 'native-base';
import { useForm, Controller, useController } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import {
    GIFTCARD_FLOWS,
    i18nFn,
    observer,
    useSpringBigStore,
    useUpdateMember,
} from '@springbig/shared';
import { useToast } from '~/hooks/toast';
import { Caption } from '~/shared/Typography';
import { Modal, Button, Input } from '~/shared/Theme';

const schema = yup.object().shape({
    firstName: yup.string().required('First name is required'),
    lastName: yup.string().required('Last name is required'),
});

interface FormData {
    firstName: string;
    lastName: string;
}

export const ProfileCompleteName = ({
    isOpen,
    onClose,
    t,
    onSubmitAction,
    type = 'default'
}: {
    isOpen: boolean,
    onClose: () => void,
    t: i18nFn,
    onSubmitAction?: GIFTCARD_FLOWS | undefined,
    type?: 'default' | 'pay'
}) => {

    const {
        control,
        handleSubmit,
        formState: { errors }
    } = useForm<FormData>({
        resolver: yupResolver(schema),
    });

    const {
        mutate: updateMember,
        status
    } = useUpdateMember();

    const { successToast } = useToast();

    const {
        member,
    } = useSpringBigStore();

    const { field: firstNameField } = useController({
        control,
        defaultValue: member.first_name || '',
        name: 'firstName',
    });

    const { field: lastNameField } = useController({
        control,
        defaultValue: member.last_name || '',
        name: 'lastName',
    });

    const onSubmit = (data: FormData) => {

        updateMember({
            member: {
                first_name: data.firstName,
                last_name: data.lastName,
                confirming_identity: true
            },
        });
        successToast(t('profile.profile_updated'));
        onClose();
    };

    useEffect(() => {

        if (status === 'success') {
            if (onSubmitAction) {
                observer.emit('open-actionsheet', onSubmitAction);
            }
        }
    }, [status]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} closeable>
            { type === 'default' &&
                <Modal.Header>
                    <Caption text={'giftCard.nameCompletionFormTitle'} />
                </Modal.Header>
            }
            <Modal.Body>
                <VStack py={4} space={4}>
                    { type === 'pay' &&
                        <Caption
                            textAlign="center"
                            fontSize="lg"
                            text={member.first_name || member.last_name ? 'giftCard.nameComfirmTitle' : 'giftCard.nameCompletionFormTitle'}
                        />
                    }
                    <FormControl isRequired isInvalid={'firstName' in errors}>
                        <FormControl.Label>
                            <Caption text={'general.first_name'} />
                        </FormControl.Label>
                        <Controller
                            control={control}
                            name={'firstName'}
                            render={({ field: { onChange, onBlur, value } }) => (

                                <Input
                                    {...firstNameField}
                                    placeholder={'John'}
                                    onBlur={onBlur}
                                    onChangeText={onChange}
                                    value={value}
                                />
                            )}
                        />
                        { errors.firstName &&
                            <Text color="red.500">
                                { errors.firstName.message }
                            </Text>
                        }
                    </FormControl>
                    <FormControl isRequired isInvalid={'lastName' in errors}>
                        <FormControl.Label>
                            <Caption text={'general.last_name'} />
                        </FormControl.Label>
                        <Controller
                            control={control}
                            name={'lastName'}
                            render={({ field: { onChange, onBlur } }) => (

                                <Input
                                    {...lastNameField}
                                    placeholder={'Doe'}
                                    onBlur={onBlur}
                                    onChangeText={onChange}
                                />
                            )}
                        />
                        { errors.lastName &&
                            <Caption color="red.500">
                                { errors.lastName.message }
                            </Caption>
                        }
                    </FormControl>
                </VStack>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    text={'general.update'}
                    onPress={handleSubmit(onSubmit)}
                />
            </Modal.Footer>
        </Modal>
    );
};

